export default __webpack_public_path__ + "static/media/Double720_2.c9923d18.jpg";